import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { personsAPI } from '../services/api';
import { Person } from '../types';
import Pagination from './Pagination';
import { usePagination } from '../hooks/usePagination';

const PersonsReviewQueue: React.FC = () => {
  const [persons, setPersons] = useState<Person[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [attempt, setAttempt] = useState(0);
  const { currentPage, pageSize, paginatedData, totalItems, goToPage, setPageSize } = usePagination({ data: persons, initialPageSize: 10 });

  useEffect(() => {
    let active = true;
    setLoading(true);
    setError(false);
    personsAPI.getPersonsForReview().then(data => {
      if (active) setPersons(data);
    }).catch(() => {
      if (active) setError(true);
    }).finally(() => {
      if (active) setLoading(false);
    });
    return () => { active = false; };
  }, [attempt]);

  if (!loading && !error && persons.length === 0) return null;

  return (
    <section className="card mb-4" aria-label="Contacts for review">
      <div className="card-header">
        <h5 className="card-title mb-0">Contacts for review{!loading && !error ? ` (${persons.length})` : ''}</h5>
      </div>
      <div className="card-body">
        {loading ? <p className="text-muted mb-0" role="status">Loading contacts for review...</p> : error ? (
          <div role="alert">
            <p>Failed to load contacts for review.</p>
            <button type="button" className="btn btn-secondary" onClick={() => setAttempt(value => value + 1)}>Retry</button>
          </div>
        ) : (
          <>
            <div className="table-responsive">
              <table className="table table-hover">
                <thead><tr><th>Person</th><th>Company</th><th>Review reason</th><th><span className="visually-hidden">Actions</span></th></tr></thead>
                <tbody>{paginatedData.map(person => (
                  <tr key={person.id}>
                    <td><strong>{[person.firstName, person.lastName].filter(Boolean).join(' ') || 'Unnamed contact'}</strong>
                      {person.emails?.[0]?.address && <div className="small text-muted">{person.emails[0].address}</div>}
                    </td>
                    <td>{person.importCompanyName || 'Unassigned'}</td>
                    <td>{person.reviewReason || 'Complete contact details and assign a customer.'}</td>
                    <td><Link className="btn btn-sm btn-primary" to={`/persons/edit/${person.id}?redirect=%2F`}>Review</Link></td>
                  </tr>
                ))}</tbody>
              </table>
            </div>
            <Pagination currentPage={currentPage} totalItems={totalItems} itemsPerPage={pageSize} onPageChange={goToPage} onPageSizeChange={setPageSize} pageSizeOptions={[5, 10, 25, 50]} />
          </>
        )}
      </div>
    </section>
  );
};

export default PersonsReviewQueue;
